/****************************************************
 * Module Name:  addTradingcompanyModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import TradingcompanyProxy from "../../utility/proxy/manager/tradingcompanyProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddTradingcompanyModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newtradingcompany: this.props.editOperation ? this.props.sourceData.name : "",
      newdescription: this.props.editOperation ? this.props.sourceData.description : "",
      newaddress: this.props.editOperation ? this.props.sourceData.address : "",
      newstate: this.props.editOperation ? this.props.sourceData.state : "",
      newemail: this.props.editOperation ? this.props.sourceData.email : "",
      newphone: this.props.editOperation ? this.props.sourceData.phone : "",
      newtelephone: this.props.editOperation ? this.props.sourceData.telephone : "",
      newfax: this.props.editOperation ? this.props.sourceData.fax : "",
      newintcom1: this.props.editOperation ? this.props.sourceData.intcom1 : "",
      newintcom2: this.props.editOperation ? this.props.sourceData.intcom2 : "",
      newgstno: this.props.editOperation ? this.props.sourceData.gstno : "",
      newpanno: this.props.editOperation ? this.props.sourceData.panno : "",
      newmemohtml: this.props.editOperation ? this.props.sourceData.memohtml : "",
      newexporthtml: this.props.editOperation ? this.props.sourceData.exporthtml : "",
      newlocalhtml: this.props.editOperation ? this.props.sourceData.localhtml : "",
      newlocalbank: this.props.editOperation ? this.props.sourceData.localbank : "",
      newexportbank: this.props.editOperation ? this.props.sourceData.exportbank : "",
      newbankdetail3: this.props.editOperation ? this.props.sourceData.bankdetail3 : "",
      newmixexporthtml: this.props.editOperation ? this.props.sourceData.mixexporthtml : "",
      newmixlocalhtml: this.props.editOperation ? this.props.sourceData.mixlocalhtml : "",

      showError: false,

      validateTradingcompanyPresentSpinner: false,
      showValidationMessage: false,
      tradingcompanyAvailable: true,
      emailValidationError: "",
      tradingcompanyValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newtradingcompany,
      description: this.state.newdescription,
      address: this.state.newaddress,
      state: this.state.newstate,
      email: this.state.newemail,
      phone: this.state.newphone,
      telephone: this.state.newtelephone,
      fax: this.state.newfax,
      intcom1: this.state.newintcom1,
      intcom2: this.state.newintcom2,
      gstno: this.state.newgstno,
      panno: this.state.newpanno,
      memohtml: this.state.newmemohtml,
      exporthtml: this.state.newexporthtml,
      localhtml: this.state.newlocalhtml,
      localbank: this.state.newlocalbank,
      exportbank: this.state.newexportbank,
      bankdetail3: this.state.newbankdetail3,
      mixexporthtml: this.state.newmixexporthtml,
      mixlocalhtml: this.state.newmixlocalhtml,
      location_id: this.props.sourceData.location_id,
      memo_per_page_stone_count: this.props.sourceData.memo_per_page_stone_count,
      invoice_per_page_stone_count: this.props.sourceData.invoice_per_page_stone_count,
      mixinvoice_per_page_bucket_count: this.props.sourceData.mixinvoice_per_page_bucket_count,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateTradingcompanyPresent = (tradingcompanyEntered) => {
    if (!tradingcompanyEntered || tradingcompanyEntered.trim() === "") return;

    this.setState({
      validateTradingcompanyPresentSpinner: true,
    });

    TradingcompanyProxy.CheckTradingcompanyAvailable(
      tradingcompanyEntered,
      (response) => {
        //if we got response that means tradingcompany is present at backend
        if (response) {
          //TradingcompanyName already present
          this.setState({
            validateTradingcompanyPresentSpinner: false,
            showValidationMessage: true,
            tradingcompanyAvailable: false,
          });
        } else {
          //TradingcompanyName not available, so can be used
          this.setState({
            validateTradingcompanyPresentSpinner: false,
            showValidationMessage: true,
            tradingcompanyAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.tradingcompanyAvailable ||
        this.state.emailValidationError.length > 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add trading company validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Trading Company"
                : "Add New Trading Company"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Trading Company Id.</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Trading Company <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newtradingcompany}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Trading company (required)"
                          placeholder="Enter Trading company"
                          value={this.state.newtradingcompany}
                          autoFocus
                          onBlur={(e) =>
                            this.validateTradingcompanyPresent(
                              this.state.newtradingcompany
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newtradingcompany: e.target.value,
                              showValidationMessage: false,
                              tradingcompanyValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Tradingcompany Cannot be Empty",
                            })
                          }
                          helperText={this.state.tradingcompanyValidationError}
                          error={
                            this.state.tradingcompanyValidationError.length > 0
                          }
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td>
                      {this.state.validateTradingcompanyPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.tradingcompanyAvailable ? (
                        <font color="green">Tradingcompany available</font>
                      ) : (
                        <font color="red">Tradingcompany not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Address</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Address"
                        placeholder="Enter Address"
                        value={this.state.newaddress}
                        onChange={(e) =>
                          this.setState({ newaddress: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>State</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="State"
                        placeholder="Enter State"
                        value={this.state.newstate}
                        onChange={(e) =>
                          this.setState({ newstate: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Email</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Email"
                        size="small"
                        placeholder="Enter Email"
                        value={this.state.newemail}
                        onChange={(e) =>
                          this.setState({
                            newemail: e.target.value,
                            emailValidationError:
                              e.target.value.length !== 0
                                ? Utility.CheckIsEmail(e.target.value)
                                  ? ""
                                  : "Enter valid email"
                                : "",
                          })
                        }
                        helperText={this.state.emailValidationError}
                        error={this.state.emailValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Phone</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Phone"
                        size="small"
                        placeholder="Enter Phone"
                        value={this.state.newphone}
                        onChange={(e) =>
                          this.setState({ newphone: e.target.value.replace(/[^0-9]/gi, "").replace(/^0+/g, "") || "0" })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Telephone</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Telephone"
                        size="small"
                        placeholder="Enter Telephone"
                        value={this.state.newtelephone}
                        onChange={(e) =>
                          this.setState({ newtelephone: e.target.value.replace(/[^0-9]/gi, "").replace(/^0+/g, "") || "0" })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Fax</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Fax"
                        size="small"
                        placeholder="Enter Fax"
                        value={this.state.newfax}
                        onChange={(e) =>
                          this.setState({ newfax: e.target.value.replace(/[^0-9]/gi, "").replace(/^0+/g, "") || "0" })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Intcom1</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Intcom1"
                        size="small"
                        placeholder="Enter Intcom1"
                        value={this.state.newintcom1}
                        onChange={(e) =>
                          this.setState({ newintcom1: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Intcom2</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Intcom1"
                        size="small"
                        placeholder="Enter Intcom2"
                        value={this.state.newintcom2}
                        onChange={(e) =>
                          this.setState({ newintcom2: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>GST No</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="GST No"
                        placeholder="Enter GST No"
                        value={this.state.newgstno}
                        onChange={(e) =>
                          this.setState({ newgstno: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>PAN No</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="PAN No"
                        placeholder="Enter PAN No"
                        value={this.state.newpanno}
                        onChange={(e) =>
                          this.setState({ newpanno: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Memo HTML</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Memo HTML"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="Memo HTML"
                        value={this.state.newmemohtml}
                        onChange={(e) =>
                          this.setState({ newmemohtml: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Export HTML</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Export HTML"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="Export HTML"
                        value={this.state.newexporthtml}
                        onChange={(e) =>
                          this.setState({ newexporthtml: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Local HTML</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Local HTML"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="Local HTML"
                        value={this.state.newlocalhtml}
                        onChange={(e) =>
                          this.setState({ newlocalhtml: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>LOCAL BANK JSON</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="LOCAL BANK JSON"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="LOCAL BANK JSON"
                        value={this.state.newlocalbank}
                        onChange={(e) =>
                          this.setState({ newlocalbank: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>EXPORT BANK JSON</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="EXPORT BANK JSON"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="EXPORT BANK JSON"
                        value={this.state.newexportbank}
                        onChange={(e) =>
                          this.setState({ newexportbank: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Bank Detail 3 JSON</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Bank Detail 3 JSON"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="Bank Detail 3 JSON"
                        value={this.state.newbankdetail3}
                        onChange={(e) =>
                          this.setState({ newbankdetail3: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>MIX Export HTML</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="MIX Export HTML"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="MIX Export HTML"
                        value={this.state.newmixexporthtml}
                        onChange={(e) =>
                          this.setState({ newmixexporthtml: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>MIX Local HTML</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="MIX Local HTML"
                        size="large"
                        multiline
                        maxRows={5}
                        placeholder="MIX Local HTML"
                        value={this.state.newmixlocalhtml}
                        onChange={(e) =>
                          this.setState({ newmixlocalhtml: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              variant="contained"
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
